import { GlTableLite, GlBadge, GlLink, GlTooltipDirective as GlTooltip } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__, n__ } from '~/locale';
import HelpIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/help_icon/help_icon.vue?vue3';
import { CI_RESOURCE_DETAILS_PAGE_NAME, CI_RESOURCE_DETAILS_USAGE_TAB } from '~/ci/catalog/router/constants';
export default {
    name: 'CiAnalyticsList',
    components: {
        GlTableLite,
        GlBadge,
        GlLink,
        HelpIcon
    },
    directives: {
        GlTooltip
    },
    props: {
        resources: {
            type: Array,
            required: true
        }
    },
    computed: {
        items () {
            return this.resources.map((resource)=>{
                return {
                    name: resource.name,
                    detailsPath: this.getDetailsPath(resource),
                    usagePath: this.getUsagePath(resource),
                    latestVersion: this.getLatestVersion(resource),
                    usageStatistics: this.getUsageStatistics(resource),
                    components: this.getComponents(resource)
                };
            });
        }
    },
    methods: {
        getDetailsPath (item) {
            return {
                name: CI_RESOURCE_DETAILS_PAGE_NAME,
                params: {
                    id: item?.fullPath
                }
            };
        },
        getUsagePath (item) {
            return {
                ...this.getDetailsPath(item),
                query: {
                    tab: CI_RESOURCE_DETAILS_USAGE_TAB
                }
            };
        },
        getLatestVersion (item) {
            const latestVersion = item?.versions?.nodes[0] || {};
            return latestVersion?.name || s__('CiCatalog|Unreleased');
        },
        getUsageStatistics (item) {
            const usageCount = item?.last30DayUsageCount || 0;
            return n__('CiCatalog|%d project', 'CiCatalog|%d projects', usageCount);
        },
        getComponents (item) {
            const components = item?.versions?.nodes[0]?.components?.nodes || [];
            return components.map((component)=>component.name).join(', ');
        }
    },
    fields: [
        {
            key: 'projects',
            label: s__('CiCatalog|Projects')
        },
        {
            key: 'usageStatistics',
            label: s__('CiCatalog|Usage statistics')
        },
        {
            key: 'components',
            label: s__('CiCatalog|Components'),
            tdClass: '!gl-text-subtle'
        }
    ]
};
